// extracted by mini-css-extract-plugin
export default {"container":"style_container__uSkip","icon":"style_icon__dmerp","info":"style_info__WKXS0","title":"style_title__Hye8k","last":"style_last__9czo2"};